import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Analytics.module.css";
import TitleSubtitle from "../../components/common/TitleSubtitle";
import TabSwitcher from "./components/TabSwitcher";
import TrackSection from "./sections/TrackSection";
import HubSection from "./sections/HubSection";
import { AnalyticsTab } from "./types";
import { useOwnerAccess } from "../../hooks/useOwnerAccess";

const Analytics: React.FC = () => {
    const { t } = useTranslation();
    const tt = t as unknown as (k: string) => string;
    const { hasAccess: isOwner } = useOwnerAccess();

    const [tab, setTab] = useState<AnalyticsTab>("tracks");
    /** Tabs opened at least once — kept mounted (hidden) so list fetches and
     *  filter state survive tab switches without re-calling get-products, etc. */
    const [visitedTabs, setVisitedTabs] = useState<Set<AnalyticsTab>>(() => new Set(["tracks"]));

    useEffect(() => {
        setVisitedTabs((prev) => {
            if (prev.has(tab)) return prev;
            const next = new Set(prev);
            next.add(tab);
            return next;
        });
    }, [tab]);

    return (
        <div className={styles.page}>
            <div className={styles.header}>
                <TitleSubtitle title={tt("analyticTitle")} subtitle={tt("analyticSubtitle")} addMargin={false} />

                <div className={styles.tabBar}>
                    <TabSwitcher
                        value={tab}
                        onChange={setTab}
                        labelTracks={tt("analyticsTabTracks")}
                        labelHubs={tt("analyticsTabHubs")}
                    />
                </div>
            </div>

            <div className={styles.section}>
                {visitedTabs.has("tracks") && (
                    <div className={styles.sectionPanel} hidden={tab !== "tracks"} aria-hidden={tab !== "tracks"}>
                        <TrackSection isOwner={isOwner} />
                    </div>
                )}
                {visitedTabs.has("hubs") && (
                    <div className={styles.sectionPanel} hidden={tab !== "hubs"} aria-hidden={tab !== "hubs"}>
                        <HubSection isOwner={isOwner} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Analytics;
